import type { RouteObject } from 'react-router';
import AppLayout from './components/layout/AppLayout';
import { ToastLayout } from './components/Toaster';
import AuditPage from './pages/AuditPage';
import DeploymentsPage from './pages/deployments/DeploymentsPage';
import DevicePage from './pages/DevicePage';
import JobPage from './pages/jobs/JobPage';
import JobsPage from './pages/jobs/JobsPage';
import LoginPage from './pages/LoginPage';
import MigrationDetailPage from './pages/migrations/MigrationDetailPage';
import MigrationsPage from './pages/migrations/MigrationsPage';
import MigrationWizardPage from './pages/migrations/MigrationWizardPage';
import NotFoundPage from './pages/NotFoundPage';
import OverviewPage from './pages/OverviewPage';
import ProjectPage from './pages/project/ProjectPage';
import ProjectsPage from './pages/ProjectsPage';
import RouteErrorPage from './pages/RouteErrorPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import SharedValuesPage from './pages/SharedValuesPage';
import TargetPage from './pages/target/TargetPage';
import VpsDetailPage from './pages/vps/VpsDetailPage';
import VpsListPage from './pages/vps/VpsListPage';
import VpsNewPage from './pages/vps/VpsNewPage';
import VpsTerminalPage from './pages/vps/VpsTerminalPage';

/** Route table (shared by the browser router and render tests). */
export const routes: RouteObject[] = [
  {
    // Toasts render inside the router so their messages can link to jobs.
    element: <ToastLayout />,
    children: [
      { path: '/login', element: <LoginPage />, errorElement: <RouteErrorPage /> },
      { path: '/device', element: <DevicePage />, errorElement: <RouteErrorPage /> },
      {
        path: '/',
        element: <AppLayout />,
        errorElement: <RouteErrorPage />,
        children: [
          {
            errorElement: <RouteErrorPage />,
            children: [
              { index: true, element: <OverviewPage /> },
              { path: 'projects', element: <ProjectsPage /> },
              { path: 'projects/:key', element: <ProjectPage /> },
              { path: 'deployments', element: <DeploymentsPage /> },
              { path: 'targets/:id', element: <TargetPage /> },
              { path: 'jobs', element: <JobsPage /> },
              { path: 'jobs/:id', element: <JobPage /> },
              { path: 'migrations', element: <MigrationsPage /> },
              { path: 'migrations/new', element: <MigrationWizardPage /> },
              { path: 'migrations/:id', element: <MigrationDetailPage /> },
              { path: 'vps', element: <VpsListPage /> },
              { path: 'vps/new', element: <VpsNewPage /> },
              { path: 'vps/:id', element: <VpsDetailPage /> },
              { path: 'vps/:id/terminal', element: <VpsTerminalPage /> },
              { path: 'shared', element: <SharedValuesPage /> },
              { path: 'audit', element: <AuditPage /> },
              { path: 'notifications', element: <NotificationsPage /> },
              { path: 'settings', element: <SettingsPage /> },
              { path: '*', element: <NotFoundPage /> },
            ],
          },
        ],
      },
    ],
  },
];
